import styled from 'styled-components';

export const StyledTitleContainer = styled.div`
  font-weight: 700;
  font-size: 70px;
  line-height: 86px;
  color: ${({ theme }) => theme.colors.Violet};
`;

export const StyledMessageContainer = styled.div`
  font-size: 24px;
  font-weight: 400;
  line-height: 30px;
  // color: ${({ theme }) => theme.colors.RiverBed};
`;
